import { Flex, Heading, Input, Center, Box, Text, FormControl, FormLabel, Button } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import Divider from "../components/chat/Divider";
import Footer from "../components/chat/Footer";
import MessagesAnalysis from "../components/chat/MessagesAnalysis";
import Home from "../components/chat/Home";
import Suggestions from "../components/chat/Suggestions";
import Header from "../components/chat/Header";
import { useParams } from "react-router-dom";
import { usePublicFetch } from "../hooks/usePublicFetch";
import { v4 as uuidv4 } from 'uuid';
import FooterTest from "./chat/FooterTest";

const ManageAnalysisTest = () => {
  const {id} = useParams();

  const [messages, setMessages] = useState([]);
  const [history, setHistory] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState(null);
  const [uuid, setUuid] = useState(''); //uuid for the user
  const { data, error, isPending } = usePublicFetch(`${process.env.REACT_APP_API_URL}/bot/` + id);

  const [password, setPassword] = useState('');
  const [hideScreen, setHideScreen] = useState(true);

  //create a uuid on page load for the user
  useEffect(() => {
    setUuid(uuidv4())
  }, [])

  if (isPending) {
    return <div></div>
  }

  if (error) {
    return <div>{ error }</div>
  }

  if (data && data.active === false) {
    return (
      <Heading>This chatbot is currently unavailable. If you are the owner, check your dashboard.</Heading>
      )
  }

  if (data && data.rules.welcomeMessage && messages.length === 0) {
    setMessages([{ from: "computer", text: data.rules.welcomeMessage }]);
    setHistory([{ role: 'assistant', content: data.rules.welcomeMessage }]);


    if (data.rules.leadingQuestion === "Yes" && data.rules.additionalWelcomeMessage) {
        setMessages((old) => [...old, { from: "computer", text: data.rules.additionalWelcomeMessage }]);
        setHistory((old) => [...old, { role: 'assistant', content: data.rules.additionalWelcomeMessage }]);
    }
  }

  const handleSendMessage = async () => {
    
    if (!inputMessage.trim().length) {
      //console.log('empty msg');
      return;
    }

    setLoading(true)
    setMessages((old) => [...old, { from: "me", text: inputMessage }]);
    setHistory((old) => [...old, { role: 'user', content: inputMessage }])
    setInputMessage("");

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/chat/analysis/` + id, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          question: inputMessage,
          chatID: uuid,
        }),
      });

      if (!response.ok) {
        // Try to parse error response body for more details
        let errorMessage = `HTTP error! status: ${response.status}`;
        let errorDetails = null;
        
        try {
          // Get response as text first to see what we're dealing with
          const responseText = await response.text();
          console.error('Error response raw text:', responseText);
          console.error('Error response status:', response.status);
          console.error('Error response statusText:', response.statusText);
          
          // Try to parse as JSON
          try {
            errorDetails = JSON.parse(responseText);
            console.error('Error response parsed JSON:', errorDetails);
            
            if (errorDetails.error) {
              errorMessage = errorDetails.error;
            } else if (errorDetails.message) {
              errorMessage = errorDetails.message;
            } else if (errorDetails.msg) {
              errorMessage = errorDetails.msg;
            } else {
              errorMessage = responseText || errorMessage;
            }
          } catch (parseError) {
            // Not JSON, use the raw text
            errorMessage = responseText || response.statusText || errorMessage;
          }
        } catch (e) {
          console.error('Error reading response body:', e);
          errorMessage = response.statusText || errorMessage;
        }
        
        throw new Error(errorMessage);
      }

      const data = await response.json();
      console.log('data', data);

      if (!data || !data.result) {
        throw new Error('Invalid response format');
      }

      console.log(data.result.type)

      const explanation = data.result.explanation; // Replace this with actual explanation logic

      if (data.result.type === 'string') {
        setMessages((old) => [...old, { from: "computer", text: data.result.data, explanation: data.result.explanation }]);
      }

      else if (data.result.type === 'dataframe') {
        setMessages((old) => [...old, { from: "dataframe", text: data.result.data, explanation: data.result.explanation }]);
      }

      else if (data.result.type === 'image') {
        setMessages((old) => [...old, { from: "image", text: data.result.data, explanation: data.result.explanation }]);
      }


      if (explanation != "" && explanation != null && data.result.data != "I had an issue querying your data. Try rephrasing your question or request.") {
        setMessages((oldMessages) => [
          ...oldMessages,
          { from: "computer", text: explanation }
        ]);
      }


      /* setSuggestions([['Need more help?'], ["Ask another question"]]); */
      setLoading(false);
      

    } catch (error) {
      console.error('Analysis chatbot error:', error);
      setLoading(false);
      
      // Provide more helpful error messages
      let errorMessage = "Hmm, I think our wires got crossed. Can you say that again?";
      
      if (error.message && error.message.includes("500")) {
        errorMessage = "The chatbot encountered an error processing your request. This may be due to a missing or invalid OpenAI API key configuration. Please check your chatbot settings to ensure your OpenAI API key is properly configured.";
      } else if (error.message && (error.message.includes("Error processing request") || error.message.includes("500"))) {
        errorMessage = "This chatbot encountered an error processing your request. We have temporarily disabled Analysis chatbots. Please use Discovery chatbots instead.";
      } else if (error.message && error.message.includes("HTTP error")) {
        errorMessage = "The chatbot encountered an error connecting to the server. Please try again or check your chatbot settings.";
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      setMessages((old) => [...old, { from: "computer", text: errorMessage }]);
    }
  };

  console.log(messages)

  const handleReset = () => {
    setMessages([]);
    setHistory([]);
    setInputMessage("");
    setSuggestions(null);
    setUuid(uuidv4());

    if (data && data.rules.welcomeMessage && messages.length === 0) {
        setMessages([{ from: "computer", text: data.rules.welcomeMessage }]);
        setHistory([{ role: 'assistant', content: data.rules.welcomeMessage }]);
    
    
        if (data.rules.additionalWelcomeMessage) {
            setMessages((old) => [...old, { from: "computer", text: data.rules.additionalWelcomeMessage }]);
            setHistory((old) => [...old, { role: 'assistant', content: data.rules.additionalWelcomeMessage }]);
        }
      }
  }

  console.log(messages)

  const handleExplainResult = async () => {
    if (messages.length === 0) return;
  
    const lastMessage = messages[messages.length - 1];
  
    // Call API or logic to get the explanation for the last message
    // For this example, I'm directly using `lastMessage.text` as the explanation
    const explanation = lastMessage.explanation; // Replace this with actual explanation logic
  
    // Append new message with explanation
    setMessages((oldMessages) => [
      ...oldMessages,
      { from: "computer", text: explanation }
    ]);
  };


  return (
    <Flex w="100%" height = {`calc(100vh - 5rem)`} justify="center" align="center">
      <Flex w="100%" h="100%" flexDir="column">
        <Divider />
        <MessagesAnalysis loading = {loading} messages={messages} bot_id = {id} onExplainResult={handleExplainResult}/>
        <Divider />
        <FooterTest
          handleReset={handleReset}
          inputMessage={inputMessage}
          setInputMessage={setInputMessage}
          handleSendMessage={handleSendMessage}
          loading={loading}
          powered_by = {data.powered_by}
          customTypeMessage= {data.customTypeMessage}
        />
      </Flex>
    </Flex>
  );
};

export default ManageAnalysisTest;
